import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import type { ListContextType, ListProps } from "./List.types";
import ListItem, { ListContext } from "./ListItem";

export class List extends React.PureComponent<ListProps> {
	public static readonly Item = ListItem;

	private getContextValue(): ListContextType {
		const { itemStyle } = this.props;

		return {
			itemStyle,
		};
	}

	public render(): ReactNode {
		const { children, itemStyle, variant, size, className, inline, spacing } = this.props;
		const classes = compact([
			"list-style",
			itemStyle === "number" && `list-style-number`,
			itemStyle === "circled-number" && `list-style-circled-number`,
			variant && `list-${variant}`,
			size && `list-${size}`,
			inline && "list-inline",
			spacing && `list-spacing-${spacing}`,

			className,
		]).join(" ");

		return (
			<ListContext.Provider value={this.getContextValue()}>
				<ul className={classes}>{children}</ul>
			</ListContext.Provider>
		);
	}
}
